import React from 'react';
import { Form, Input, Button, Checkbox } from 'antd';
import "../styles/contactform.css"


const layout = {
    labelCol: {
        span: 8,
    },
    wrapperCol: {
        span: 16,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 16,
    },
};

function ContactFrom(props) {
    const onFinish = (values) => {
        console.log('Success:', values);
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    return (
        <form id="contact-form">
            <h1>Admission</h1>
            <input placeholder="Full Name" required disabled />
            <input placeholder="Email" type="email" required disabled />
            <input placeholder="Phone" type="phone" required disabled />
            <button type='button' disabled>Submit</button>
        </form>
    );
}

export default ContactFrom;
